var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":"","column":"","fill-height":""}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("tune")]),_c('h4',[_vm._v(_vm._s(_vm.$t('learning')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }